var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '@mui/material';
import { useTheme } from '@mui/system';
import { useAnalytics } from 'hx-analytics';
import imageOldLadyWithHeadphones from '../assets/images/side-images/old-lady-with-headphones.webp';
import { useDinPlayerContext } from 'hx-din-test-2';
import { AnimatedCircles, SideImageLayout, StartButton } from 'hx-ui';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { AshaLogo } from '../components/AshaLogo';
export function WelcomePage() {
    var theme = useTheme();
    var navigate = useNavigate();
    var rootState = useSelector(function (state) { return state; });
    var sendButtonClick = useAnalytics(rootState).sendButtonClick;
    var _a = useDinPlayerContext(), initialize = _a.initialize, progress = _a.state.progress;
    var handleStartClick = function () {
        sendButtonClick('session-start');
        initialize().then(function () { return navigate('/setup'); });
    };
    return (_jsx(SideImageLayout, { imageLeft: imageOldLadyWithHeadphones, header: _jsxs("header", __assign({ className: "grid gap-4 px-4 pt-16 place-content-center" }, { children: [_jsx(Typography, __assign({ variant: "h1" }, { children: "Hearing Screener" })), _jsxs(Typography, __assign({ variant: "subhead" }, { children: ["Know your hearing status in ", _jsx("strong", { children: "2 minutes." })] }))] })), content: _jsx("main", __assign({ className: "container max-w-lg mx-auto" }, { children: _jsx(StartButton, { onClick: handleStartClick, progress: progress, color: theme.palette.secondary.main, GraphicElement: AnimatedCircles, buttonStyles: {
                    color: theme.palette.common.white,
                    minWidth: '7.25rem',
                    minHeight: '7.25rem',
                } }) })), footer: _jsxs("footer", __assign({ className: "grid gap-2 px-20 place-items-center" }, { children: [_jsx(AshaLogo, {}), _jsxs(Typography, __assign({ variant: "small" }, { children: ["Validated speech-in-noise hearing test", _jsx("br", {}), "(2016 International Journal of Audiology, 2018 Ear and Hearing)"] }))] })) }));
}
export default WelcomePage;
